module.exports = __webpack_public_path__ + "static/media/ZA.a67bf488.png";